import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

/**
 * Catch-all route. Without this, an unknown client-side path rendered the Layout with a
 * blank <main>, which reads as a broken page rather than a wrong URL.
 */
export default function NotFoundPage() {
  return (
    <>
      <Helmet>
        <title>Page Not Found | Decisive Sites</title>
        <meta name="robots" content="noindex" />
      </Helmet>

      <div className="max-w-2xl mx-auto px-4 py-16 sm:py-24 text-center">
        <p className="text-sm font-semibold uppercase tracking-wide text-primary-700">404</p>
        <h1 className="mt-2 text-3xl font-bold text-gray-900 sm:text-4xl">
          We couldn&rsquo;t find that page
        </h1>
        <p className="mt-4 text-gray-600">
          The link may be out of date. You can start a new order below, or contact us if you were
          sent here from an email.
        </p>

        <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            to="/"
            className="inline-flex items-center justify-center px-6 py-3 rounded-lg bg-primary-600 text-white font-medium hover:bg-primary-700 transition-colors focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
          >
            Start a new order
          </Link>
          <a
            href="https://decisivesites.com/support/"
            rel="noopener"
            className="inline-flex items-center justify-center px-6 py-3 rounded-lg border border-gray-300 text-gray-700 font-medium hover:bg-gray-50 transition-colors focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
          >
            Contact support
          </a>
        </div>
      </div>
    </>
  );
}
